// Helper functions for domain validation and processing

// Helper function to get logo URL
export function getCompanyLogoUrl(domain: string): string {
  return `https://company-logo.hunter.io/${domain}`
}

// Helper function to extract hostname from URL/input
export function hostnameFromURL(input: string): string {
  input = input.toLowerCase().trim()
  input = input.replace(/^@/, "")

  if (input.indexOf(" ") !== -1 || input.indexOf("@") !== -1) {
    return input
  }

  let hostname: string
  try {
    const url = new URL(input)
    hostname = url.hostname
  } catch {
    const tempUrl = document.createElement("a")
    tempUrl.href = `http://${input}`
    hostname = tempUrl.hostname
  }

  return hostname.replace(/^(www\.)/, "")
}

// Helper function to check if input is a valid domain
export function isADomainName(input: string): boolean {
  const re = /^(((?!-)(xn--)?[a-z0-9-_]{0,61}[a-z0-9]{1,1}\.)*(xn--)?([a-z0-9-]{1,61}|[a-z0-9-]{1,30})\.[a-z]{2,})$/
  return re.test(input)
}
